// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"310":"1bfb161d","402":"d355ecaa","457":"ceb03fac","549":"fcb42a91","640":"fcb42a91","917":"0706c829"}[chunkId] + ".chunk.css";
};